import Request from '../Request';
import tooltipData from '../data/tooltip_mozu-furu';

/**
 * もずふる古墳群マップアプリ用コード
 * TODO: 汎用的に使える部分はモジュール化したい
 *
 * @type {IHMozuFuru}
 */
module.exports = class IHMozuFuru extends IH {
  constructor(options) {
    super(options);
  
    /**
     * 変数
     */
    this.options = options;
    this.searchTargetTypes = [];
    this.initLocationOrigin = {}; // 管理画面で設定された初期位置の保存用
    this._placeTypes = [];
    this.tooltipData = tooltipData;
    
    // GoogleMap マップタイプ・マップコントロール設定
    if (this.mapOptions.type === 'googlemap') {
      const gmap_options = {
        mapTypeId: google.maps.MapTypeId.TERRAIN,
        mapTypeControlOptions: {
          position: google.maps.ControlPosition.RIGHT_BOTTOM,
          style: google.maps.MapTypeControlStyle.HORIZONTAL_BAR,
          mapTypeIds: ['terrain', 'satellite']
        },
        streetViewControlOptions: {position: google.maps.ControlPosition.RIGHT_TOP},
        zoomControlOptions: {position: google.maps.ControlPosition.TOP_LEFT}
      };
      $.extend(true, this.mapOptions.gmap_options, gmap_options)
    }
    
    this.repositoryOptions = {
      type: 'facet',
      placeTypeFacetName: this.translationsExtend.facet.moundShape.name,
      searchApi: 'search',
      mappingItems: {
        lat:         'lat',
        lng:         'lng',
        image:       'image',
        image_label: this.translationsExtend.attributes.imageLabel,
        name:        this.translationsExtend.attributes.name,
        address:     this.translationsExtend.attributes.address,
        description: this.translationsExtend.attributes.description
      },
      sortTarget: {
        mound:       this.translationsExtend.attributes.moundLength,
        era:         this.translationsExtend.facet.era.name,
        haniwa_era: '埴輪編年'
      },
      sortValue: {
        // 日本史時代区分
        eras: {},
        // 埴輪編年時代区分
        haniwa_eras: {
          '三期1-2': 1,
          '三期1-3': 2,
          '三期2-1': 3,
          '三期2-2': 4,
          '三期2-3': 5,
          '四期1-1': 6,
          '四期1-2': 7,
          '四期1-3': 8,
          '四期2': 9,
          '四期3-1': 10,
          '四期3-2': 11,
          '四期3-3': 12,
          '四期3-4': 13,
          '五期1': 14,
          '5期2以降': 15,
          '該当なし': 1000
        }
      },
      firstSelection: this.translationsExtend.facet.candidate.value.yes
    };
    this.defaultSortKey = 'mound';
    this.defaultSortOrder = -1;
    this.sortKey_1 = 'mound';
    this.sortOrder_1 = -1;
    this.sortKey_2 = 'era';
    this.sortOrder_2 = 1;
    this.detailMenus = [
      this.translationsExtend.attributes.no,
      this.translationsExtend.attributes.kana,
      this.translationsExtend.facet.area.name,
      this.translationsExtend.attributes.address,
      this.translationsExtend.attributes.access,
      this.translationsExtend.attributes.moundLength,
      this.translationsExtend.facet.era.name
    ];
    this.indexOfCandidate = 0;
    this.indexOfKana = 1;
    this.indexOfMoundLength = 5;
  
    if (this.locale === 'ja') {
      this.repositoryOptions.sortValue.eras = {
        "4世紀後半": 1,
        "5世紀前半": 2,
        "5世紀後半": 3,
        "不明": 1000
      };
    } else if (this.locale === 'en') {
      this.repositoryOptions.sortValue.eras = {
        "the second half of the 4th century": 1,
        "the first half of the 5th century": 2,
        "the second half of the 5th century": 3,
        "unknown": 1000
      };
      this.detailMenus[3] = this.translationsExtend.facet.district.name;
    }
  
    /**
     * 固有設定
     */
    if (this.isProduction) {
      this.googleAnalyticsCode = this.options.googleAnalyticsCode;
    }
    this.numOfMap = 3;
    this.icon_default = this.icon_file_path + 'base_pin.png';
    this.labelingZoomLevel = 15;
    this.extent = null;               // 閲覧範囲制限
    this.specialSearchPhase = 'off';  // 築造順表示処理の段階
    this.highlightInterval = 1750;
    this.specialFacetValues = [       // 築造順表示対象の古墳データを取得する専用のファセット値
      '三期1-2',
      '三期1-3',
      '三期2-1',
      '三期2-2',
      '三期2-3',
      '四期1-1',
      '四期1-2',
      '四期1-3',
      '四期2',
      '四期3-1',
      '四期3-2',
      '四期3-3',
      '四期3-4',
      '五期1',
      '5期2以降',
      this.translationsExtend.facet.moundLength.value.over200
    ];
    // 古代地形図の表示座標
    this.terrainMapBounds = {
      north: 34.8962,
      south: 34.4518,
      east: 135.7214,
      west: 135.3416
    };
    // 地図ビュー切替え時の地図中心位置
    this.defaultMapCenter = {
      lat: 34.581911,
      lng: 135.549748
    }
    // 展示モード用の初期位置（「グランフロント大阪・ナレッジキャピタル」）
    this.initLocationOnBigpad = {
      lat: 34.705913,
      lng: 135.494468
    };
    this.geolocationBounds = {
      minLat: 34.274057,
      maxLat: 35.051187,
      minLng: 135.091399,
      maxLng: 135.746522
    };
    this.showDetailFromTooltipMode = false;
  }
  
  reset() {
    super.reset();
    this.init();
  }
  
  init() {
    let that = this;
    let urlParams = that.getQueryString();
    let moundShape = that.translationsExtend.facet.moundShape.name;
    let moundLengthName = that.translationsExtend.facet.moundLength.name;
    let moundLengthDetail = that.translationsExtend.attributes.moundLength;
    let moundEra = that.translationsExtend.facet.era.name;
    
    // 展示モード(URLパラメータ: "bigpad=true")の場合、
    // 　・初期位置を「グランフロント大阪・ナレッジキャピタル」に変更する
    // 　・管理画面で設定された初期位置は initLocationOrigin に保存する
    // (※ Mapオブジェクト生成前の処理)
    if ('bigpad' in urlParams) {
      that.initLocationOrigin = that.init_location;
      that.init_location = that.initLocationOnBigpad;
      this.mapOptions.gmap_options_default.zoom = 12;
    }
    
    $(that).on('ready', function(){
      that.show_direction_on_marker_click = false;
      
      // ビューポートに地図を表示する操作の設定
      that.controlFeatureAndViewPort();
      
      // 非表示ファセット値による検索範囲の限定
      that.searchBySecretFacetValue([that.repositoryOptions.firstSelection]);
      
      // GoogleAnalyticsで取得するイベントの設定
      that.setGoogleAnalytics();
  
      // 地形図表示
      that.controlTerrainMapLayers();
  
      // 築造順表示
      that.controlConstructionOrderSearch();

      // fitBoundsと古墳マーカの設定
      that.setFitBoundsAndMarkerImage();
      //
      // // 築造順表示
      // that.controlConstructionOrderSearch();
      //
      // // ズームレベルによる古墳マーカのラベルの表示・非表示の切替え
      that.showMarkerLabelByZoomLevel();
  
      // ツールチップから詳細パネル表示
      that.showDetailFromTooltip();
      
      // 検索結果タイル表示時は特集メニューを無効化
      $('.ih-expand-result-button').on('click', () => {
        $('.mf-footer-menu-feature').addClass('ui-disabled');
      });
      $('.ih-collapse-result-button').on('click', () => {
        $('.mf-footer-menu-feature').removeClass('ui-disabled');
      });
  
      // GPS現在地連動モードに移行
      $('.js-user-location').on('click', function(){
        let elm = $(this);
        that.shiftToLocationMode().then(function(){
          elm.closest('.ui-popup').popup('close');
        });
        return false;
      });
      
      // 展示モードの場合、
      //　・<body> に bigpadクラスを付与する
      //　・閲覧範囲を制限する
      // (※ Mapオブジェクト生成後の処理)
      if (urlParams.bigpad) {
        $('body').addClass('bigpad');
        that.extent = new google.maps.LatLngBounds(
          new google.maps.LatLng(that.terrainMapBounds.south, that.terrainMapBounds.west),
          new google.maps.LatLng(that.terrainMapBounds.north, that.terrainMapBounds.east)
        );
        that.map.getMap().addListener('center_changed', evt => that.restrictBounds(evt));
      }
    });
  
    // サイドパネルの検索結果一覧に墳丘長と築造時代を表示する
    // 画像一覧に資産番号を表示する
    $(that).on('ihFillSearchResult', (event, place, item) => {
      let text = moundLengthName + ' ' + place.attributes[moundLengthDetail] + ', ' + place.attributes[moundEra];
      item.find('.sr-info').text(text);
  
      let no = place.attributes[ that.translationsExtend.attributes.no ].toString();
      let $no = $('<span class="mf-tile-kofun-no">[' + no + '] </span>');
      $no.prependTo(item.find('.sr-name'));
    });
    
    // マーカポップアップ・詳細パネルの内容を書換える
    $(that).on('ihFillMarkerPopup', function (event, place, popup) {
      // 詳細パネル: アプリ固有の項目を作成する
      that.createDetailMenus(place, popup);
      // 詳細パネル: 画像ポップアップを作成する
      that.createImagePopup(place, popup);
      // マーカポップアップに墳丘長と築造時代を表示する
      let markerInfo = moundLengthName + ' ' + place.attributes[moundLengthDetail] + ', ' + place.attributes[moundEra];
      popup.find('.iw-desc').text(markerInfo);
    });
  }
  
  /**
   *
   * @override
   * @protected
   */
  beforeStart() {
    return this.initFacets();
  }
  
  /**
   * ファセット一覧を取得して施設タイプを設定する
   *
   * @returns {*}
   */
  initFacets() {
    return this.repository.loadFacets().then(() => {
      this.setOptionsForPlaceTypes(this.repository.getPlaceTypes());
    });
  }
  
  /**
   * @override
   * @returns {Array}
   */
  getSearchTargetTypes() {
    let types = [];
    for (let i in this.searchTargetTypes) {
      if (this.searchTargetTypes[i]) {
        types.push(i);
      }
    }
    return types;
  }
  
  /**
   * 詳細パネル: アプリ固有の項目を作成する
   *
   * @param place
   * @param popup
   */
  createDetailMenus(place, popup){
    for (let i = 0, len = this.detailMenus.length; i < len; i++ ) {
      let attr = this.detailMenus[i];
      let text = '';
      let index = i + 1;
      
      // 施設オブジェクトに項目名と同じプロパティあれば、プロパティ値を項目の内容として表示
      if (attr in place.attributes) {
        text = place.attributes[attr];
        
        if ( i === this.indexOfCandidate && text !== '' ) {
          text = '[' + text.toString() + '] ';
          popup.find('.mf-kofun-number').text(text);
        }
        if ( i === this.indexOfMoundLength ) {
          attr = this.translationsExtend.facet.moundLength.name;
        }
        if ( this.locale === 'en' &&  i === this.indexOfKana ) {
          text = '';
        }
        
        if ( i === this.indexOfCandidate || text !== '' ) {
          popup.find('.iw-facet-' + index).closest('.iw-item').find('.iw-label').text(attr);
          popup.find('.iw-facet-' + index).html(text);
          popup.find('.iw-facet-' + index).closest('.iw-item').show();
        } else {
          popup.find('.iw-facet-' + index).closest('.iw-item').hide();
        }
        
        
      } else {
        popup.find('.iw-facet-' + index).closest('.iw-item').hide();
      }
    }
  }
  
  /**
   * 詳細パネル: 画像スライダー付きポップアップウィンドウを作成する
   *
   * @param place
   * @param popup
   */
  createImagePopup(place, popup){
    let credit = [];
    if ( place.image && popup.find('.iw-image-popup').length ){
      let imagePaths = place.image.split('|');
      let imageTitle = place.name + '（' + place.attributes[ this.translationsExtend.facet.moundShape.name ] + '）';
      let numOfImages = imagePaths.length;
      credit = place.image_label.split('|');
  
      // 画像パス・写真提供元を整形
      for(let i = 0; i < numOfImages; i++) {
        // 改行や空白を削除
        imagePaths[i] = imagePaths[i].replace(/[\n\r\s]/g, '');
    
        // 画像パスがURLでなければ、ローカルパスを追加
        if (!imagePaths[i].match(/^http/)) {
          imagePaths[i] = this.place_image_path + imagePaths[i];
        }
      }
  
      // 画像枚数が2枚以上なら、ポップアップボタンの下に枚数表示
      if(numOfImages > 1){
        let that = this;
        $('.iw-image-count').each(function () {
          $(this).text(numOfImages + that.translationsCommon.imageSlider.number);
        });
      } else {
        $('.iw-image-count').each(function () {
          $(this).text('');
        });
      }
  
      popup.find('.iw-image-popup').show();
      let imagePopupContainer = popup.find('.iw-image-popup .iw-label');
      let imagePopup = $('#image-popup');
      
      // 画像ポップアップウィンドウとスライダの作成
      if ( imagePopup.length === 0 ){
        imagePopup = $('<div id="image-popup" data-role="popup" data-overlay-theme="a" data-theme="d" data-corners="false"></div>').appendTo( imagePopupContainer );
        imagePopup.popup();
        
        // ポップアップを閉じるボタンを追加
        let closer = $('<button id="image-popup-closer" data-theme="b" class="ui-btn ui-corner-all ui-shadow ui-btn-inline ui-btn-up-b">' + this.translationsExtend.ui.close + '</button>');
        closer.appendTo(imagePopup);
        closer.on('click', function () {
          imagePopup.popup('close');
        });
        
        // ポップアップを閉じるボタンのデザイン
        // ここで設定しないとデザインが反映されない
        closer.css({
          'padding': '5px 12px',
          'font-size': '1em'
        });
      }
      
      $('#image-slider').remove();
      $('.bx-wrapper').remove();
      
      // スライダー用のdiv要素を作成し、ポップアップウィンドウに追加
      let imageSlider = $('<div id="image-slider"></div>');
      imageSlider.appendTo(imagePopup);
  
      // img要素を作成し、スライダー用divに追加
      for(let i = 0; i < numOfImages; i++) {
        // 画像は1枚目のみ読み込み、他はスライド直前に読み込み（遅延ロード）
        // 遅延ロードさせないと、ポップアップウィンドウ表示時に画像が一瞬縦に並んでしまう
        if (i === 0) {
          $('<div class="sliding-images"><img src="' + imagePaths[i] + '" title="' + imageTitle + '" id="sliding-image-' + i + '"></div>').appendTo(imageSlider);
        } else {
          $('<div class="sliding-images"><img title="' + imageTitle + '" id="sliding-image-' + i + '"></div>').appendTo(imageSlider);
        }
      }
      
      // ポップアップウィンドウの表示完了後にスライダを作成
      // これまでスライド作成できない不具合があったのは、恐らくポップアップ表示完了前にスライダが生成されいたため
      imagePopup.on( "popupafteropen", ( event, ui )=> {
        imageSlider.bxSlider({
          minSlides: 1,
          maxSlides: 1,
          slideMargin: 5,
          infiniteLoop: false,
          hideControlOnEnd: true,
          captions: true,
          // 画像遅延ロード
          onSlideBefore: function($slideElement, oldIndex, newIndex){
            $('#sliding-image-' + newIndex).attr('src', imagePaths[newIndex]);
            $('.mf-carousel-credit').remove();
            if (credit[newIndex] !== 'none') {
              $('.bx-caption span').append('<span class="mf-carousel-credit">' + credit[newIndex] + '</span>');
            }
          },
          onSliderLoad: function (currentIndex) {
            $('.mf-carousel-credit').remove();
            if (credit[0].indexOf('none') === -1) {
              $('.bx-caption span').append('<span class="mf-carousel-credit">' + credit[0] + '</span>');
            }
          }
        });
      });
    }else{
      popup.find('.iw-image-popup').hide();
    }
    
    if (place.image_label && popup.find('.iw-image-label').length){
      popup.find('.iw-image-label-item').show();
      popup.find('.iw-image-label').text(credit[0]);
    }else{
      popup.find('.iw-image-label-item').hide();
    }
  }
  
  /**
   * 閲覧範囲を制限する
   *
   */
  restrictBounds() {
    if (this.extent.contains(this.map.getCenter())) {
      return;
    }
    
    let maxLat = this.extent.getNorthEast().lat(),
        maxLng = this.extent.getNorthEast().lng(),
        minLat = this.extent.getSouthWest().lat(),
        minLng = this.extent.getSouthWest().lng(),
        lat = this.map.getCenter().lat(),
        lng = this.map.getCenter().lng();
  
    if (maxLat < lat) {
      lat = maxLat;
    }
    if (maxLng < lng) {
      lng = maxLng;
    }
    if (minLat > lat) {
      lat = minLat;
    }
    if (minLng > lng) {
      lng = minLng;
    }
    
    // setCenter()による即時中心位置変更ができなくなった
    this.map.getMap().panTo(this.map.createLatLng(lat, lng));
  }
  
  /**
   * 未表示の施設オブジェクトを取得する
   */
  getNotDisplayedPlaces(){
    // 表示中のマーカを取得
    let markers = this.map.getDisplayMarkers();
    // 表示予定の施設オブジェクトを取得
    let places = this.map.getDisplayingPlaces();
    
    // 未表示の施設オブジェクトを返す
    _.remove(places, function(place){
      let flag = false;
      for (let key in markers) {
        if (place.id == key) {
          flag = true;
          break;
        }
      }
      return flag;
    });
    return places;
  }
  
  /**
   * 築造順表示の自動再生・早送りの処理
   *
   * @param mode - 再生モード(1: 自動再生, 4: 早送り)
   */
  startSpecialSearch(mode){
    // 「古墳群の表示をクリア」「自動再生」「次を表示」「早送り」を無効化する
    // 「一時停止」は、「自動再生」の時は有効化、「早送り」の時は無効化する
    // 　・disabled = [古墳群の表示をクリア, 自動再生, 一時停止, 次を表示, 早送り]
    // 　・true: 無効化、false: 有効化
    let disabled = [true, true, mode === 4, true, true];
    this.disableSpecialSearchMenu(disabled);
    
    if (mode === 4) {
      this.map.closeMarkerPopup();
    }
    
    // 築造順表示処理の段階が「一時停止」の場合、表示を再開する
    if (this.specialSearchPhase === 'pausing') {
      // 再生速度(マーカ描画間隔、ハイライト間隔)を設定する
      this.setPlaySpeed(mode);
      // 未表示の古墳オブジェクトを取得する
      let places = this.getNotDisplayedPlaces();
      // 築造順表示処理の段階を「表示中」にする
      this.specialSearchPhase = 'displaying';
      // 未表示の古墳を表示する
      this.map.displayMarkers(null, places);
      return;
    }
  
    // 築造順表示処理の段階を「表示中」にする
    this.specialSearchPhase = 'displaying';
    // 検索メニュー、並替えボタンを無効化する
    this.disableNormalSearchMenu(true);
    // 古墳群選択ボタンを無効化する
    $('.mf-cluster-selector').addClass('ui-disabled');
    // 築造順テーブルの古墳名を灰色にする(グレーアウト)
    // 築造順表示と共に以下のように色を変化させて、表示状態を伝える
    // 　・未表示: 文字（灰色）
    // 　・表示中: 文字（黒色）＋ 背景（緑色）
    // 　・表示済: 文字（黒色）
    $('.mf-const-table td').addClass('before-highlighting');
    // 築造順表示用の検索設定を行う（リポジトリ、再生速度、検索メニュー）
    this.initSpecialSearch(mode);
    // 築造順表示用の検索クエリを生成する
    this.setSpecialSearchQuery();
    // 古墳データを検索する
    this.searchFromBaseMarker();
  }
  
  pauseSpecialSearch(){
    if (this.specialSearchPhase === 'stepping') {
      // ステップ再生中は「一時停止」と「結果クリア」を無効化する
      let disabled = [true, false, true, false, false];
      this.disableSpecialSearchMenu(disabled);
    } else {
      // 「一時停止」のみ無効化する
      let disabled = [false, false, true, false, false];
      this.disableSpecialSearchMenu(disabled);
    }
    
    if (this.specialSearchPhase !== 'displayed') {
      // 築造順表示処理の段階を「一時停止」にする
      this.specialSearchPhase = 'pausing';
    }
    
    // タイマー表示を停止するIDを取得する
    let timerID = this.map.getTimerID();
    // タイマー表示を停止する（築造順表示の一時停止）
    if (timerID.length !== 0) {
      for (let i = 0; i < timerID.length; i++) {
        clearTimeout(timerID[i]);
      }
    }
  }
  
  stepSpecialSearch(){
    // 検索メニュー、並替えボタンを無効化する
    this.disableNormalSearchMenu(true);
    // 自動再生を実行する（）
    this.startSpecialSearch(1);
    // 築造順表示処理の段階を「ステップ再生」にする
    // 「ステップ再生」中は、自動再生でマーカを１つ表示した後、一時停止がかかる
    this.specialSearchPhase = 'stepping';
  }
  
  /**
   * 通常検索・築造順表示に関わらず
   * ・検索結果を0にする
   * ・全49基の古墳表示ボタンを有効にする
   */
  terminateSpecialSearch(){
    // 築造順表示処理の段階が「一時停止」の場合
    if (this.specialSearchPhase === 'pausing') {
      // 表示間隔を0秒に戻す
      this.map.interval = 0;
      // 築造順テー  ブルのグレーアウトを元に戻す
      $('.mf-const-table td').removeClass('before-highlighting');
    }
    
    // 築造順表示処理の段階を「オフ」にする
    this.specialSearchPhase = 'off';
    // 古墳マーカを消去する
    this.searchTargetTypes = [];
    this.searchFromBaseMarker();
    
    let zeroClear = true;
    $(this.controller).on('ihAfterUpdateFacetValue', () => {
      if (zeroClear) {
        this.searchBySecretFacetValue([this.repositoryOptions.firstSelection]);
        this.initSearchMenu();
        this.controller.clearAllSelector();
        $('#all-clear-button').prop('disabled', false);
        $('#all-clear').find('.ui-btn-inner').css('color', 'black');
      }
      zeroClear = false;
    });
    
    // 検索メニュー、並替えボタンを有効化する
    this.disableNormalSearchMenu(false);
    // 操作ボタンの有効・無効を初期状態に戻す
    let disabled = [true, false, true, false, false];
    this.disableSpecialSearchMenu(disabled);
    // 古墳群選択ボタンを有効化する
    $('.mf-cluster-selector').removeClass('ui-disabled');
    this.repository.sortOrder = -1;
    this.repository.sortKey = 'mound';
    $('select.ih-result-sort-menu').val('1').selectmenu('refresh');
    const selectors = ['.ih-footer-menu-result', '.hz-view-change-button-group'];
    this.enableUi(selectors);
  }
  
  /**
   * 検索パネル、結果パネルの並替えボタンの有効・無効を切替る
   *
   * @param {boolean} disabled
   */
  disableNormalSearchMenu(disabled){
    if (disabled) {
      $('.js-search-type').addClass('ui-disabled');
      $('.ih-list-controller').addClass('ui-disabled');
    } else {
      $('.js-search-type').removeClass('ui-disabled');
      $('.ih-list-controller').removeClass('ui-disabled');
    }
  }
  
  /**
   * 築造順表示操作ボタンの有効・無効を切替る
   * @param {Array} disabled - 各ボタンの設定値
   * @example
   *  disabled = [true, false, false, true, false]
   *  // ボタンの割当て: [古墳群の表示をクリア, 自動再生, 一時停止, 次を表示, 早送り]
   *  // true: 無効化、false: 有効化
   */
  disableSpecialSearchMenu(disabled){
    let i, elem;
    $('.mf-ctrl-btn').each(function () {
      i = parseInt($(this).val(), 10);
      elem = $(this).parent().parent();
      if ( disabled[i] ) {
        elem.addClass('ui-disabled');
      } else {
        elem.removeClass('ui-disabled');
      }
    });
  }
  
  /**
   * 築造順表示用の検索の初期設定を行う
   *
   * @param {Number} mode - 再生モード(1: 自動再生, 4: 早送り)
   */
  initSpecialSearch(mode){
    // 築造順表示ボタンの場合、古墳データの並替え順を設定する
    this.repository.sortOrder = 1;
    // 古墳データの並替えキーを、埴輪編年順に設定する
    this.repository.sortKey = 'haniwa_era';
    $('select.ih-result-sort-menu').val('2').selectmenu('refresh');
    // 再生速度(マーカ描画間隔、ハイライト間隔)を設定する
    this.setPlaySpeed(mode);
    // 検索メニューの選択をクリアする
    this.controller.clearAllSelector();
    this.searchTargetTypes = [];
    this.searchBySecretFacetValue([this.repositoryOptions.firstSelection]);
  }
  
  /**
   * 再生速度(マーカ描画間隔、ハイライト間隔)を設定する
   *
   * @param {Number} mode - 再生モード(1: 自動再生, 4: 早送り)
   */
  setPlaySpeed(mode){
    if (mode === 1) {
      this.searchSpeed = 'normal';
      this.map.interval = 2000;
      this.highlightInterval = 1750;
    }
    if (mode === 4) {
      this.searchSpeed = 'fast-forward';
      this.map.interval = 1000;
      this.highlightInterval = 750;
    }
  }
  
  /**
   * 築造順表示用の検索クエリを生成する
   */
  setSpecialSearchQuery(){
    // 選択されたボタンの種類（大規模 or 大規模＋中小規模）を取得する
    let selectBtn = parseInt($("input[name='cluster']:checked").val(), 10);
    // 築造順表示専用のファセット値(埴輪編年)の組合わせによる、選択値テーブルを設定する
    for (let fi = 0; fi < this.specialFacetValues.length; fi++) {
      for (let pi = 0; pi < this._placeTypes.length; pi++) {
        // 選択したボタンが「大規模＋中小規模」(value=0)の場合、ファセット値「200m以上」は無効にする
        if ( selectBtn === 1 && this.specialFacetValues[fi] === this.translationsExtend.facet.moundLength.value.over200 ) {
          continue;
        }
        if (this.specialFacetValues[fi] === this._placeTypes[pi].name) {
          this.searchTargetTypes[ this._placeTypes[pi].id ] = true;
        }
      }
    }
  }
  
  /**
   * ツールチップから特定の古墳のみ表示する（検索メニューとは独立）
   */
  showDetailFromTooltip(){
    const that = this;
    $('.mf-tooltip-to-detail').on('click', function () {
      let placeType = $(this).data('kofun');
      
      // 築造順表示モードの場合、築造順表示処理の段階を「オフ」にし、並び替えキーを墳丘長順にする
      if (that.specialSearchPhase !== 'off') {
        that.specialSearchPhase = 'off';
        that.repository.sortOrder = -1;
        that.repository.sortKey = 'mound';
        $('select.ih-result-sort-menu').val('1').selectmenu('refresh');
      }
      
      $('.js-tooltip-display').popup('close');
      
      // ID検索を応用
      that.searchById(placeType);
    });
  }
  
  controlFeatureAndViewPort () {
    const selectors = ['.ih-footer-menu-result', '.hz-view-change-button-group'];
    const viewBtn = $('.hz-view-change-button-group input');
    
    $('.mf-footer-menu-feature').on('click', () => {
      if (!this.isMapViewDisplayed()) {
        this.showMapView();
        viewBtn.val(['map']).checkboxradio("refresh");
      }
    });
    $('.mf-motion-selector').on('click', () => {
      if (!this.isMapViewDisplayed()) {
        this.showMapView();
        viewBtn.val(['map']).checkboxradio("refresh");
        this.disableUi(selectors);
      }
    });
    $('.ih-footer-menu-search').on('click', () => {
      if (this.isMapViewDisplayed()) {
        this.showTileView();
        viewBtn.val(['tile']).checkboxradio("refresh");
      }
    });
  }
  /**
   * ビューポートの表示が地図かどうか
   *
   * @returns {Boolean}
   */
  isMapViewDisplayed () {
    const $mapViewDisplayer = $('.hz-map-view-button');
    return $mapViewDisplayer.prop('checked');
  }
  
  /**
   * 非表示ファセット値で検索範囲を限定する
   * @param facetValues
   */
  searchBySecretFacetValue (facetValues) {
    const facetValueIds = this.repository.getFacetValueIdsByName(facetValues);
    const len = facetValueIds.length;
    for (let i = 0; i < len; i++) {
      if (facetValueIds[i]) {
        this.searchTargetTypes[facetValueIds[i]] = true;
      }
    }
  }
  
  /**
   * 地形図レイヤー作成・表示変更
   * 特集 地形図表示機能専用
   *
   * @private
   */
  controlTerrainMapLayers () {
    // 地形図切替時にヘッダーにセットするアプリ名の設定
    const $header = $('#header h1.ui-title');
    const defaultTitle = this.options.title;
    const terrainMapTitle = this.options.title + this.translationsExtend.ancientMap.kofun;
  
    // 古墳時代地形図レイヤー作成
    const mapLayer = this.map.createStaticImageLayer(
      this.place_image_path + 'img/maps/3.jpg',
      this.terrainMapBounds,
      0.65
    );
    
    $('.mf-map-selector').on('change', () => {
      const checked = $('.mf-kofun-era-terrain-map').prop('checked');
      if (checked) {
        $header.text(terrainMapTitle);
        // 地形図表示
        this.map.addLayer(mapLayer);
        // 地形図の中心位置を調整
        const center = this.map.createLatLng(this.defaultMapCenter.lat, this.defaultMapCenter.lng);
        this.map.setCenter(center);
        // ビューポートが写真一覧の場合は地図に切り替え
        // ビューポートが地図の場合はズームを調整
        if (!this.isMapViewDisplayed()){
          this.forceChangeViewport('map');
        } else {
          this.map.setZoom(this.defaultZoom)
        }
      } else {
        $header.text(defaultTitle);
        this.map.removeLayer(mapLayer);
      }
    });
  }
  
  controlConstructionOrderSearch () {
    const that = this;
    const moundLengthName = that.translationsExtend.facet.moundLength.name;
    const moundLengthValue = that.translationsExtend.facet.moundLength.value.over200;
    // 築造順テーブルの破線ハイライトされている行数（初期値: 2）
    // 　・行数は本来0スタート
    // 　・tdボトムに枠線デザインが施されている箇所があるため、tdトップに破線を表示
    // 　・1行目(0)と最後はハイライト用の空行
    // 　・テーブル中の古墳以前の、テーブル未表示の古墳(2行目tdトップの破線で表示)は現状無い
    // 　・そのため、3行目(2)tdトップがスタート位置になる
    let trCount = 2;
    // 築造順テーブルの全行（TR, 破線ハイライト対象）
    let allTR = $('.mf-const-table tr');
    // 破線ハイライト対象のTD
    let dottedTD = null;
    // 背景色ハイライト対象のTD
    let colouredTD = null;
  
    // リクエストを生成するためのファセットID情報源としてplaceTypeを取得する
    this._placeTypes = this.placeType.getAll();
  
    // 築造順表示操作ボタンの処理: 自動再生、一時停止、ステップ再生、早送り、表示消去
    $('.mf-ctrl-btn').on('click', function () {
      // 築造順テーブルのハイライトを元に戻す
      let constTD = $('.mf-const-table td');
      constTD.removeClass('highlighting');
      constTD.removeClass('top-dotted');
    
      // 築造順表示操作ボタンのの種類を取得する
      let selectBtn = parseInt($(this).val(), 10);
    
      // 自動再生、早送り
      if (selectBtn === 1 || selectBtn === 4) {
        that.startSpecialSearch(selectBtn);
      }
      // 一時停止
      if (selectBtn === 2) {
        that.pauseSpecialSearch();
      }
      // ステップ再生
      if (selectBtn === 3) {
        that.stepSpecialSearch();
      }
      // 表示消去
      if (selectBtn === 0) {
        // 築造順テーブルのハイライトする行を元に戻す
        trCount = 2;
        that.terminateSpecialSearch();
      }
    });
  
    // 築造順表示用の古墳オブジェクトをリクエスト後の処理
    $(this).on('ihAfterRequestPlaces', (event, request, places) => {
      // 築造順表示処理の段階が「表示中」「表示後」「ステップ再生」の場合
      if (this.specialSearchPhase === 'displaying' ||
        this.specialSearchPhase === 'displayed'  ||
        this.specialSearchPhase === 'stepping') {
        
        // 築造順表示処理の段階が「表示中」「ステップ再生」の場合
        if (this.specialSearchPhase === 'displaying' || this.specialSearchPhase === 'stepping') {
          // 検索メニューの各データ数を初期化することで有効化された検索メニューを再び無効化する
          $('.js-search-type').addClass('ui-disabled');
        }
      }
    });
  
    // 検索メニューの各データ数を初期化する
    // 築造順表示のための検索は、検索メニューからの検索とは独立に動作させるため
    $(this.controller).on('ihAfterUpdateFacetValue', () => {
      if (that.specialSearchPhase !== 'off') {
        this.initSearchMenu();
      }
    });
  
    // 築造順表示用の古墳マーカが１つ表示されるごとの処理
    $(this.map).on('ihDisplayedOneMarker', function (event, places, place, marker, popup){
      // 築造順表示処理の段階が「ステップ再生」の場合
      if (that.specialSearchPhase === 'stepping') {
        // 一時停止を実行する
        that.pauseSpecialSearch();
        // 築造順表示処理の段階を「一時停止」から「ステップ再生」に変更する
        that.specialSearchPhase = 'stepping'
      }
    
      // 築造順表示処理の段階が「表示中」「ステップ再生」の場合
      if (that.specialSearchPhase === 'displaying' || that.specialSearchPhase === 'stepping') {
        // 「自動再生」の場合、対象の古墳マーカのポップアップを開く
        // (「早送り」では開かない)
        if (that.searchSpeed === 'normal') {
          that.map.toggleMarkerPopup(marker, popup);
        }
      
        $('.mf-const-kofun').each(function(){
          let kofunName = $(this).find('.mf-const-kofun-name').text();
          if (kofunName === place.name) {
            // 築造順テーブルの表示中の古墳名の背景を薄緑でハイライトし、文字色を黒にする
            colouredTD = $(this);
            colouredTD.removeClass('before-highlighting');
            colouredTD.addClass('highlighting');
            // 築造順テーブルのハイライトする行を1つ進める
            trCount++;
          }
        });
      
        // 表示対象の古墳が中小規模の場合
        if ( place.attributes[moundLengthName] !== moundLengthValue ) {
          // 破線ハイライト対象のTDを取得する
          if ( place.attributes[ that.translationsExtend.facet.area.name ] === that.translationsExtend.facet.area.value.mozu ) {
            dottedTD = allTR.eq(trCount).find('td').eq(0);
          } else {
            dottedTD = allTR.eq(trCount).find('td').eq(1);
          }
          // 対象のTDを破線でハイライトする
          dottedTD.addClass('top-dotted');
        }
      
        // 築造順表示処理の段階が「ステップ再生」の場合
        if (that.specialSearchPhase === 'stepping') {
          // 築造順表示処理の段階を「一時停止」にする
          // 表示を再開した時に続きから表示するため（ = 一時停止後の処理にするため）
          that.specialSearchPhase = 'pausing';
          // ただし、最後の古墳を表示した後は「表示中」にし、築造順表示UIを無効化する
          // 表示後の処理に移るため
          if (place.id === places[ places.length - 1 ].id) {
            const disabled = [true, true, true, true, true];
            that.disableSpecialSearchMenu(disabled);
            that.specialSearchPhase = 'displaying';
          }
          // ハイライトは消さない
          return;
        }
      
        // 1.75秒(自動再生) or 0.75秒(早送り)後
        setTimeout(() => {
          // 背景色ハイライトを消す
          colouredTD.removeClass('highlighting');
          if (place.attributes[moundLengthName] !== moundLengthValue) {
            // 破線ハイライトを消す
            dottedTD.removeClass('top-dotted');
          }
        }, that.highlightInterval);
      }
    });
  
    // 築造順表示用の全古墳マーカが表示された後の処理
    $(this.map).on('ihDisplayedAllMarkers', function (event, places, marker, popup){
      let disabled = [false, false, true, false, false];
      that.disableSpecialSearchMenu(disabled);
    
      if (that.specialSearchPhase === 'displaying') {
        // 築造順表示処理の段階を「表示後」にする
        that.specialSearchPhase = 'displayed';
      
        // 1.75秒(自動再生) or 0.75秒(早送り)後
        setTimeout(() => {
          const selectors = ['.ih-footer-menu-result', '.hz-view-change-button-group'];
          that.enableUi(selectors);
        
          // 検索メニュー、並替えボタンを有効化する
          that.disableNormalSearchMenu(false);
        
          // 「一時停止」以外を有効化する
          // 　・disabled = [古墳群の表示をクリア, 自動再生, 一時停止, 次を表示, 早送り]
          // 　・true: 無効化、false: 有効化
          let disabled = [false, false, true, false, false];
          that.disableSpecialSearchMenu(disabled);
        
          // 古墳群選択ボタンを有効化する
          $('.mf-cluster-selector').removeClass('ui-disabled');
        
          if (this.searchSpeed === 'normal') {
            // 対象の古墳マーカのポップアップを開く
            that.map.toggleMarkerPopup(marker, popup);
          }
        
          // 築造順テーブルのハイライトする行を元に戻す
          trCount = 2;
          // 築造順表示専用の検索クエリを空にする
          that.searchTargetTypes = [];
          that.searchBySecretFacetValue([that.repositoryOptions.firstSelection]);
        
          // 全49基表示ボタンを有効にする
          $('#all-clear-button').prop('disabled', false);
          $('#all-clear').find('.ui-btn-inner').css('color', 'black');
        
          // 表示間隔を0秒に戻す
          that.map.interval = 0;
        }, that.highlightInterval);
      }
    });
  
    // 築造順表示モードの場合、検索メニューを選んだ時、築造順表示処理の段階を「オフ」にし、並び替えキーを墳丘長順にする
    $('.js-facet-selector').on('change', function(){
      if (that.specialSearchPhase !== 'off') {
        that.specialSearchPhase = 'off';
        that.repository.sortOrder = -1;
        that.repository.sortKey = 'mound';
        $('select.ih-result-sort-menu').val('1').selectmenu('refresh');
      }
    });
  }
  
  showMarkerLabelByZoomLevel () {
    let labelStyle = {
      color: "#493E26",
      fontSize: "14px",
      fontWeight: '400',
      fontFamily: 'ヒラギノ丸ゴ Pro W4,ヒラギノ丸ゴ Pro,Hiragino Maru Gothic Pro,ヒラギノ角ゴ Pro W3,' +
        'Hiragino Kaku Gothic Pro,HG丸ｺﾞｼｯｸM-PRO,HGMaruGothicMPRO',
      text: ''
    };
    $(this).on('ihChangeZoom', (event, zoom) => {
      const markers = this.map.getDisplayMarkers();
      if (Object.keys(markers).length !== 0) {
        $.each(markers, (index, marker) => {
          if (zoom < this.labelingZoomLevel) {
            labelStyle.text = '';
            this.map.setMarkerLabel(marker, labelStyle);
          } else if (zoom >= this.labelingZoomLevel && this.specialSearchPhase === 'off') {
            if (this.mapOptions.type === 'googlemap') {
              labelStyle.text = marker.name;
            } else if (this.mapOptions.type === 'openlayer') {
              labelStyle.text = marker.get('name');
            }
            this.map.setMarkerLabel(marker, labelStyle);
          }
        });
      }
    });
  }
  
  setGoogleAnalytics () {
    if (ga) {
      // メニューボタンを押した時
      $("#footer").on("click", function (event) {
        let label = $(event.target).text().trim();
        if (label.length > 4) {
          label = label[0] + label[1];
        }
        if (label !== '') {
          ga('send', 'event', 'メニュー', 'メニューボタンを押す', label);
        }
      });
    
      // 詳細パネルを開いた時
      $("#page-place").on("panelopen", function () {
        let label = $(this).find('.iw-name').text() + '（' + $(this).find('.iw-type').text() + '）';
        ga('send', 'event', '詳細パネル', '詳細パネルを開く', label);
      
      });
    
      // 特集パネルの地形図選択ボタンを押した時
      $(".mf-map-selector").on("click", function (event) {
        let label = $(event.target).text().trim();
        if (label !== '') {
          ga('send', 'event', '古代地形図', '地形図選択ボタンを押す', label);
        }
      });
    
      // 特集パネルの築造順表示操作ボタンを押した時
      $(".mf-ctrl-btn").on("click", function (event) {
        let elem = $(event.target);
        let label = elem.text().trim();
        if (label === '') {
          label = elem.find('img').attr('alt');
        }
        if (label !== '') {
          ga('send', 'event', '築造順表示', '表示操作ボタンを押す', label);
        }
      });
    
      // 特集パネルの築造順表示操作ボタンを押した時
      $(".mf-cluster-selector").on("click", function (event) {
        let elem = $(event.target);
        let label = '';
        if (!elem.is('p')) {
          label = elem.text().trim();
        }
        if (label !== '') {
          ga('send', 'event', '築造順表示', '古墳群選択ボタンを押す', label);
        }
      });
    }
  }
  
  setFitBoundsAndMarkerImage () {
    const moundShapes = this.translationsExtend.facet.moundShape.value;
    const moundShape = this.translationsExtend.facet.moundShape.name;
    const moundLengthName = this.translationsExtend.facet.moundLength.name;
    $(this).on('ihAfterTransformPlacesResponse', (event, request, places) => {
      this.controller.options.fit_bounds = false;
    
      _.forEach( places, (value, key) => {
        // ビューポートに対象の古墳が全て収まる場合は、fitBoundsを行わない
        if (this.isMapViewDisplayed() && 
          (this.map.getNorthEnd() < value.lat ||
          this.map.getEastEnd() < value.lng    ||
          this.map.getSouthEnd() > value.lat   ||
          this.map.getWestEnd() > value.lng )
        ) {
          this.controller.options.fit_bounds = true;
        }
      
        // 古墳オブジェクトごとにマーカのアイコン画像を設定する
        if ( value.attributes[moundShape] === moundShapes.keyholeShaped )
        {
          places[key].icon_pin = this.icon_file_path + 'keyhole_pin.png';
          places[key].icon_min = this.icon_file_path + 'keyhole_min.png';
        }
        if ( value.attributes[moundShape] === moundShapes.scallopShaped )
        {
          places[key].icon_pin = this.icon_file_path + 'scallop_pin.png';
          places[key].icon_min = this.icon_file_path + 'scallop_min.png';
        }
        if ( value.attributes[moundShape] === moundShapes.round ) {
          places[key].icon_pin = this.icon_file_path + 'round_pin.png';
          places[key].icon_min = this.icon_file_path + 'round_min.png';
        }
        if ( value.attributes[moundShape] === moundShapes.square ) {
          places[key].icon_pin = this.icon_file_path + 'square_pin.png';
          places[key].icon_min = this.icon_file_path + 'square_min.png';
        }
        if ( value.attributes[moundShape] === moundShapes.unknown ) {
          places[key].icon_pin = this.icon_file_path + 'unknown_pin.png';
          places[key].icon_min = this.icon_file_path + 'unknown_min.png';
        }
      });
    });
  }
  
  /**
   * @override
   */
  searchById (id) {
    super.searchById(id);
    if (!this.isMapViewDisplayed()) {
      this.showMapView();
      $('.hz-view-change-button-group input').val(['map']).checkboxradio("refresh");
    }
  }
  initSearchTargetTypes () {
    this.searchTargetTypes = [];
    this.searchBySecretFacetValue([this.repositoryOptions.firstSelection]);
  }
  initSearchMenu () {
    const ids = this.repository.getFacetValueIdsByName([this.repositoryOptions.firstSelection]);
    const request = new Request({types: ids});
    this.controller.displayNumberOfFacetValue(request, false);
  }
};



// WEBPACK FOOTER //
// ./map/js/ih/extend/IHMozuFuruKofun.js